module.exports = __webpack_public_path__ + "img/bg-blue.220634bb.png";